import React from 'react';

import { SlideSmartMenu } from 'src/modules/designStudio/components/Toolbar/SlideSmartMenu';
import type { Menu as MenuConstants } from 'src/modules/designStudio/constants';

import { Menu } from '../Menu';

interface PropTypes {
  headerText: string | null;
  closeMenu: () => void;
  menu: MenuConstants | null;
  requestingOrgName?: string;
  toolbarRef: React.RefObject<HTMLElement> | null;
}

const DesignCard = ({
  closeMenu,
  menu,
  headerText,
  requestingOrgName,
  toolbarRef,
}: PropTypes) => (
  <SlideSmartMenu closeMenu={closeMenu} containerRef={toolbarRef} menu={menu}>
    <Menu
      closeMenu={closeMenu}
      headerText={headerText}
      menu={menu}
      requestingOrgName={requestingOrgName}
    />
  </SlideSmartMenu>
);

export { DesignCard };
